<template>
    <v-dialog v-model="dialogModel"
              max-width="80%"
              internal-activator
              :scrollable="false">

        <v-card height="800" class="pa-0" fluid>
            <iframe v-if="productBoardUrl" :src="productBoardUrl" frameborder="0" class="product-board"></iframe>
        </v-card>

    </v-dialog>

</template>

<script>

    import {mapState, mapActions} from 'vuex';

    export default {

        props: {
            value: {
                required: true,
                type: Boolean,
            }
        },

        data() {
            return {
                url: null,
            }
        },

        mounted() {
            this.getProductBoardUrl()
                .then(url => {
                    this.url = url;
                })
                .catch(() => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Sorry there is something wrong with the feedback!'
                    });
                })
        },

        computed: {

            ...mapState('PanelSettings', [
                'settings'
            ]),

            ...mapState([
                'user'
            ]),

            dialogModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },

            productBoardUrl() {
                if (this.url) {
                    return this.url;
                }
            },
        },

        methods: {
            ...mapActions(['getProductBoardUrl'])
        }
    }
</script>

<style scoped>
    .product-board {
        width: 100%;
        height: 100%;
    }
</style>